import { ComponentStyleConfig } from '@chakra-ui/react';

import { textStyles } from '../common';

export const HeadingStyles: ComponentStyleConfig = {
  baseStyle: (props) => {
    const textStyle = textStyles[props.textStyle || ''];
    let fontWeight;
    if (
      textStyle &&
      typeof textStyle === 'object' &&
      'fontWeight' in textStyle
    ) {
      fontWeight = textStyle.fontWeight;
    } else if (typeof textStyle === 'function') {
      // If textStyle is a function, call it with theme if available
      try {
        const styleObj = textStyle(props.theme);
        fontWeight = styleObj?.fontWeight;
      } catch {
        fontWeight = undefined;
      }
    }
    return {
      fontWeight,
    };
  },
  defaultProps: {
    size: '',
  },
};
